
import { Vue } from "vue-class-component";

export default class Bagging extends Vue {}
